module.exports = __webpack_public_path__ + "6397e1fcb35470342e3cf5508281208c.pdf";